export * from './product-create-edit/product-create-edit.component';
export * from './product-list/product-list.component';
export * from './product-details/product-details.component';
